(function() {
  'use strict';

  angular
    .module('admin.shinies.users', [])
    .controller('ShiniesUsersAdminCtrl', ShiniesUsersAdminCtrl);

  /** @ngInject */
  function ShiniesUsersAdminCtrl($stateParams, ShiniesAdminService) {
    var vm = this;
    vm.items = [];

    vm.load = function(){
      ShiniesAdminService.listUsers($stateParams.id).then(function(result){
        for (var i = 0; i < result.results.length; i++) {
          if (result.results[i]["ts"] !== undefined && result.results[i]["ts"] !== null) {
            result.results[i]["ts"] = new Date(
              parseInt(
                result.results[i]["ts"]
                  .toString()
                  .substring(0, result.results[i]["ts"].toString().length - 3)
              )
            );
          }
          if (result.results[i]["ts-m"] !== undefined && result.results[i]["ts-m"] !== null) {
            result.results[i]["ts-m"] = new Date(
              parseInt(
                result.results[i]["ts-m"]
                  .toString()
                  .substring(0, result.results[i]["ts-m"].toString().length - 3)
              )
            );
          }

          result.results[i].val = result.results[i].val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
        vm.items = result.results;
      });
    };

    vm.load();
  }

})();
